<template>
    <div id="app">
        <SemcogHeader>
          <span style="line-height: 2em; font-size: 1em;">
            FY 2026-2029 TIP Projects
          </span>
        </SemcogHeader>
        <MainMap
            v-bind:filter_project_name="filter_project_name"
            v-bind:filter_project_type="filter_project_type"
            v-bind:filter_construction_year="filter_construction_year"
            v-bind:filter_FAC="filter_FAC"
            v-bind:filter_street="filter_street"
            v-bind:filter_jurisdiction="filter_jurisdiction"
            v-bind:focus="focus"
            v-bind:construction_years="construction_years"
            v-bind:jurisdictions="jurisdictions"
            v-bind:FACs="FACs"
            v-bind:project_types="project_types"
            v-bind:counties="counties"
            v-bind:symbology="symbology"
            v-bind:showTable="showTable"
            v-bind:amendmentOpen="amendmentOpen"
            v-on:tableToggle="setTable($event)"
        />
        <SideBar
            v-on:input="setFilter($event)"
            v-on:symbolChange="setSymbology($event)"
            v-on:focusChange="setFocus($event)"
            v-bind:construction_years="uniqueConstructionYears"
            v-bind:FACs="uniqueFACs"
            v-bind:jurisdictions="uniqueJurisdictions"
            v-bind:filter_FAC="filter_FAC"
            v-bind:filter_construction_year="filter_construction_year"
            v-bind:filter_project_type="filter_project_type"
            v-bind:filter_street="filter_street"
            v-bind:filter_jurisdiction="filter_jurisdiction"
            v-bind:focus="focus"
            v-bind:project_types="uniqueProjectTypes"
            v-bind:counties="uniqueCounties"
            v-bind:symbology="symbology"
            v-bind:amendmentOpen="amendmentOpen"
        />
    </div>
</template>

<script>
    import MainMap from './components/MainMap.vue';
    import SemcogHeader from './components/SemcogHeader.vue';
    import SideBar from "./components/SideBar";
    import {diff} from "deep-diff";

    export default {
        name: 'App',
        components: {
            MainMap,
            SemcogHeader,
            SideBar
        },
        data: function () {
            let symbology = "Project Type";
            let showTable = "n";
            let filter_FAC = null;
            let filter_construction_year = null;
            let filter_project_type = null;
            let filter_street = null;
            let filter_jurisdiction = null;
            let focus = "Adopted";
            let amendmentOpen = true; // Set this to true to enable amendment functionality, false to hide it all

            if(this.$route.query.showTable) {
                showTable = this.$route.query.showTable;
            }
            if(this.$route.query.FAC) {
                filter_FAC = this.$route.query.FAC.split(',');
            }
            if(this.$route.query.Type) {
                filter_project_type = this.$route.query.Type.split(',');
            }
            if(this.$route.query.CONYear) {
                filter_construction_year = [];
                let split_construction_year = this.$route.query.CONYear.split(',');
                for (let i = 0; i < split_construction_year.length; i++) {
                    //filter_construction_year.push(parseInt(split_construction_year[i]));
                    filter_construction_year.push(split_construction_year[i]);
                }
            }
            if(this.$route.query.Street) {
                filter_street = this.$route.query.Street;
            }

            if(this.$route.query.Jurisdiction) {
                filter_jurisdiction = this.$route.query.Jurisdiction.split(',');
            }

            if(this.$route.query.Focus && amendmentOpen) {
                focus = this.$route.query.Focus;
            }

            // This solution works to ensure that the symbol selector works even if there is garbage in the URL
            // parameter.  It would probably be more idiomatic to somehow derive this from the objects in Groups in
            // SideBar.vue, if such a thing is possible.
            // After writing the above, I noticed that the dropdown parameters also lack validation code.
            //const validSymbols = {"Project Type":0, "Construction Year":0};
            if(this.$route.query.Symbols) {
                symbology = this.$route.query.Symbols;
            }

            return {
                amendmentOpen: amendmentOpen, // Set this to true to enable amendment functionality, false to hide it all
                symbology: symbology || null,
                showTable: showTable || "n",
                filter_project_name: null,
                filter_project_type: filter_project_type || null,
                filter_construction_year: filter_construction_year || null,
                filter_FAC: filter_FAC || null,
                filter_street: filter_street || null,
                filter_jurisdiction: filter_jurisdiction || null,
                focus: focus || null,
                construction_years: [],
                FACs: [],
                project_types: [],
                counties: [],
                jurisdictions: [],
            }
        },
        computed: {
            uniqueConstructionYears: function () {
                return this.getUnique(this.construction_years);
            },
            uniqueFACs: function () {
                return this.getUnique(this.FACs);
            },
            uniqueJurisdictions: function () {
                return this.getUnique(this.jurisdictions);
            },
            uniqueProjectTypes: function () {
                return this.getUnique(this.project_types);
            },
            uniqueCounties: function () {
                return this.getUnique(this.counties);
            },
            urlData: function () {
                let query = {};
                if (this.filter_FAC && this.filter_FAC.length) {
                    query.FAC = this.filter_FAC.toString();
                }
                if (this.filter_construction_year && this.filter_construction_year.length) {
                    query.CONYear = this.filter_construction_year.toString();
                }
                if (this.filter_project_type && this.filter_project_type.length) {
                    query.Type = this.filter_project_type.toString();
                }
                if (this.filter_street && this.filter_street.length) {
                    query.Street = this.filter_street;
                }
                if (this.filter_jurisdiction && this.filter_jurisdiction.length) {
                    query.Jurisdiction = this.filter_jurisdiction.toString();
                }
                if(this.showTable) {
                    query.showTable = this.showTable;
                }
                if (this.symbology) {
                    query.Symbols = this.symbology;
                }
                if (this.focus) {
                    query.Focus = this.focus;
                }
                return query;
            },
        },
        methods: {
            setFilter: function (id) {
                if (id[0] === "project_name") {
                    this.filter_project_name = id[1]
                }
                if (id[0] === "TYPE") {
                    this.filter_project_type = id[1]
                }
                if (id[0] === "CONYear") {
                    this.filter_construction_year = id[1]
                }
                if (id[0] === "FAC") {
                    this.filter_FAC = id[1]
                }
                if (id[0] === "RPT_LOC_DE") {
                    this.filter_street = id[1]
                }
                if (id[0] === "Jurisdiction") {
                    this.filter_jurisdiction = id[1]
                }
                if (id[0] === "Focus") {
                    this.Focus = id[1]
                }
            },
            setSymbology: function (id) {
                this.symbology = id[0];
            },
            setFocus: function (id) {
                this.focus = id;
            },
            setTable: function (id) {
                this.showTable = id[0];
            },
            getUnique: function (col) {
                return (Array.from(new Set(col)).sort() || []).map(y => {
                    if (y === null) {
                        return {name: 'Missing'}
                    }
                    return {
                        name: y,
                    }
                });
            }
        },
        watch: {
            urlData: function (newUrl, oldUrl) {
                if (diff(oldUrl, newUrl)) {
                    this.$router.replace({query: this.urlData})
                }
            },
        }
    }
</script>

<style scoped>
    #app {
        width: 100%;
        height: 100vh;
        display: grid;
        grid-template-columns: 80% auto;
        grid-template-rows: max-content auto;
        font-family: Arial, Helvetica, sans-serif;
        overflow: hidden;
    }

    @media (max-width: 576px), print {
        #app {
            height: initial;
            grid-template-columns: auto;
            grid-template-rows: max-content max-content auto;
        }
    }
</style>
